import {
  HOME,
  REPORTS_HOME,
  PRODUCTS_HOME,
  CATALOG_HOME,
  VENDORS_HOME,
  MANUFACTURERS_HOME,
  COLLABORATORS_HOME,
  COLLECTIONS_HOME,
} from './constants';

function routeFor(menu) {
  switch (menu) {
    case 'home': {
      return HOME;
    }
    case 'reports': {
      return REPORTS_HOME;
    }
    case 'products': {
      return PRODUCTS_HOME;
    }
    case 'catalog': {
      return CATALOG_HOME;
    }
    case 'vendors': {
      return VENDORS_HOME;
    }
    case 'manufacturers': {
      return MANUFACTURERS_HOME;
    }
    case 'collaborators': {
      return COLLABORATORS_HOME;
    }
    case 'collections': {
      return COLLECTIONS_HOME;
    }
    default: {
      return HOME;
    }
  }
}

export default routeFor;



// WEBPACK FOOTER //
// ./src/app/components/Routes/routeFor.js